import { useEffect, useRef } from "react";
import * as reactRouterDom from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { basicAPI } from "api";
import { setGlobalState } from "Global";

export default function Logout() {
  const navigation = reactRouterDom.useNavigate();
  const auth = useAuth();
  const hasBackendLogoutRef = useRef(false);

  useEffect(() => {
    if (auth.isLoading) return;

    if (auth.isAuthenticated) {
      auth.signoutRedirect();
      return;
    }

    if (hasBackendLogoutRef.current) return;
    hasBackendLogoutRef.current = true;

    basicAPI
      .logout()
      .then((res) => {
        if (res.status == 200) {
          setGlobalState("userDetails", null);
          navigation("/authentication/sign-in");
          setGlobalState("error", {
            open: true,
            message: "You have been successfully logged out!",
            type: "success",
            code: 200,
          });
        }
      })
      .catch(() => {
        setGlobalState("error", {
          open: true,
          message: "Error while logging out",
          type: "error",
          code: 500,
        });
      });
  }, [auth.isAuthenticated, auth.isLoading, navigation]);

  return <></>;
}
